<template>
  <div id="sales">
    <div class="container">
      <button @click="back" v-show="!showDatatable">{{$t('back')}}</button>
      <hr v-show="!showDatatable">
      <json-viewer :value="jsonError" v-show="!showDatatable"/>
      <json-viewer :value="jsonRequest" v-show="!showDatatable" :expand-depth=5 copyable boxed sort/>
    </div>
    <Datatable
        v-show="showDatatable"
        class="datatable"
        entity="test_sale"
        ref="datatable"
        :parameters="{company: companyId}"
        :onRowClick="onRowClick"
        :rowActions="[]"
    />
  </div>
</template>
<script>

import Datatable from "@/components/Datatable.vue";
import JsonViewer from 'vue-json-viewer'

export default {

  name: 'testSales',

  components: { Datatable, JsonViewer },

  data() {
    return {
      showDatatable: true,
      jsonRequest: {},
      jsonError: {}
    }
  },

  computed: {
    companyId() {
      return this.$store.state.contextCompany ? this.$store.state.contextCompany.id : undefined
    }
  },

  mounted() {
    this.$store.state.pageTitleTranslationKey = "sales.title";
    this.$store.state.pageIcon = "/icon/sales.svg";
  },

  methods: {
    onRowClick(row) {
      this.showDatatable = false;
      this.jsonError = JSON.parse(row.errors);
      this.jsonRequest = JSON.parse(row.request);
    },
    back() {
      this.jsonRequest = {};
      this.showDatatable = true;
    }
  }
};

</script>


<style lang="scss" scoped>
.datatable {
  height: 100%;
}
</style>